import { AnchorHTMLAttributes } from 'react';
import { cn } from '../utils/cn';
import { useRouter } from './RouterContext';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
}

export const Link: React.FC<LinkProps> = ({ to, onClick, className, children, ...props }) => {
  const { navigate } = useRouter();

  return (
    <a
      href={to}
      className={cn('cursor-pointer', className)}
      onClick={(event) => {
        if (onClick) {
          onClick(event);
        }
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.altKey ||
          event.ctrlKey ||
          event.shiftKey
        ) {
          return;
        }
        event.preventDefault();
        navigate(to);
      }}
      {...props}
    >
      {children}
    </a>
  );
};
